import '@/app/globals.css'

export function BlankLoadingPage() {
  return null
}
